const FileItem = require('./FileItem');
const TableState = require('./TableState');

const FILE_ITEM_ENUMS = {
    FILESYSTEM_SUBTYPE_FILE: 1,
    FILESYSTEM_SUBTYPE_DIRECTORY: 2,
    FILESYSTEM_SUBTYPE_SYMLINK: 8,
    FILESYSTEM_SUBTYPE_MOUNTPOINT: 16,
    FILESYSTEM_SUBTYPE_DISK: 32
};

class FolderItem {
    constructor() {
        this.displayName = '/';
        this.isExpanded = false;
        this._selected = false;
        this.someSelected = false;
        this.contentsLoaded = false;
        this.folders = [];
        this.content = [];
        this.fullItemName = '';
        this.subType = 0;
        this.modificationTime = 0;
        this.size;
        this.type = '';
        this.level = 0;
        this.fileTableState = new TableState();
    }

    static fromRaw(rawFolder, parent) {
        let folder = new FolderItem();

        folder.displayName = rawFolder.displayName;
        folder._selected = parent._selected;
        folder.fullItemName = rawFolder.fullItemName;
        folder.subType = rawFolder.subType;
        folder.modificationTime = rawFolder.modificationTime;
        folder.size = rawFolder.fileSize;
        folder.uuid = rawFolder.fullItemName;
        folder.level = parent.level + 20;
        folder.parent = parent;
        folder.type = rawFolder.type;
        folder.iconType = FolderItem.changeIconType(rawFolder.subType);
        folder.mounted = rawFolder.mounted;

        return folder;
    }

    addFolders(folders) {
        this.folders = folders.map(f => {
            const folder = FolderItem.fromRaw(f, this);

            if (this.content.length !== 0) {
                for (let i = 0, len = this.content.length; i < len; i++) {
                    if (this.content[i].fullItemName === folder.fullItemName) {
                        return this.content[i];
                    }
                }
            }
            for (let i = 0, len = this.folders.length; i < len; i++) {
                if (this.folders[i].fullItemName === folder.fullItemName) {
                    folder.folders = this.folders[i].folders;
                    folder.content = this.folders[i].content;
                    folder._selected = this.folders[i]._selected;
                    folder.someSelected = this.folders[i].someSelected;
                    folder.folders.forEach(f => { f.parent = folder; });
                    folder.content.forEach(c => { c.parent = folder; });
                }
            }
            return folder;
        });
    }

    addContent(content, metadata) {
        this.content = [];
        this.content = content.map(f => {
            if ((f.subType & 2) === 0) {
                return FileItem.fromRaw(f, this);
            }
            const folder = FolderItem.fromRaw(f, this);
            if (this.folders.length !== 0) {
                for (let i = 0, len = this.folders.length; i < len; i++) {
                    if (this.folders[i].fullItemName === folder.fullItemName) {
                        return this.folders[i];
                    }
                }
            }
            return folder;
        });
        this.fileTableState = TableState.fromRaw(metadata);
    }

    addPlaceholderSubFolder(name, fullItemName) {
        let folder = new FolderItem();

        folder.displayName = name;
        folder._selected = this._selected;
        folder.fullItemName = '/' + fullItemName;
        folder.level = this.level + 20;
        folder.parent = this;

        this.folders.unshift(folder);
    }

    clear() {
        this.isExpanded = false;
        this._selected = false;
        this.someSelected = false;
        this.contentsLoaded = false;
        this.folders = [];
        this.content = [];
        this.fullItemName = '';
        this.subType = 0;
        this.level = 0;
        this.fileTableState = new TableState();
    }

    static changeIconType(subType) {
        if (!subType) return;
        let type = '';
        if (FileItem.isFile(subType)) {
            if (FileItem.isSymlink(subType)) {
                type = 'icon-symfile';
            } else {
                type = 'icon-file';
            }
        } else if (FileItem.isDirectory(subType)) {
            if (FileItem.isMountPoint(subType)) {
                if (FileItem.isSymlink(subType)) {
                    type = 'icon-symmountpoint';
                } else {
                    type = 'icon-mountpoint';
                }
            } else if (FileItem.isSymlink(subType)) {
                type = 'icon-symfolder';
            } else {
                type = 'icon-folder-1';
            }
        } else if (FileItem.isMountPoint(subType)) {
            if (FileItem.isSymlink(subType)) {
                type = 'icon-symmountpoint';
            } else {
                type = 'icon-mountpoint';
            }
        } else if (FileItem.isDisk(subType)) {
            type = 'icon-hdd';
        } else if (FileItem.isSymlink(subType) && FileItem.isError(subType)) {
            type = 'icon-symfile';
        }
        return type;
    }

    static isDisk(subType) {
        return (subType & FILE_ITEM_ENUMS.FILESYSTEM_SUBTYPE_DISK) == FILE_ITEM_ENUMS.FILESYSTEM_SUBTYPE_DISK;
    }

    static isFile(subType) {
        return (subType & FILE_ITEM_ENUMS.FILESYSTEM_SUBTYPE_FILE) == FILE_ITEM_ENUMS.FILESYSTEM_SUBTYPE_FILE;
    }
    static isDirectory(subType) {
        return (subType & FILE_ITEM_ENUMS.FILESYSTEM_SUBTYPE_DIRECTORY) == FILE_ITEM_ENUMS.FILESYSTEM_SUBTYPE_DIRECTORY;
    }
    static isMountPoint(subType) {
        return (subType & FILE_ITEM_ENUMS.FILESYSTEM_SUBTYPE_MOUNTPOINT) == FILE_ITEM_ENUMS.FILESYSTEM_SUBTYPE_MOUNTPOINT;
    }
    static isSymlink(subType) {
        return (subType & FILE_ITEM_ENUMS.FILESYSTEM_SUBTYPE_SYMLINK) == FILE_ITEM_ENUMS.FILESYSTEM_SUBTYPE_SYMLINK;
    }
    static isError(subType) {
        return !(FileItem.isFile(subType) || FileItem.isDirectory(subType) || FileItem.isSymlink(subType));
    }
}

module.exports = FolderItem;


// WEBPACK FOOTER //
// ./src/azurebackup/model/FolderItem.js